if (!customElements.get('oz-bast-models')) {
  customElements.define('oz-bast-models', class extends HTMLElement {
    connectedCallback() {
      if (this.controller) return
      this.radios = [...this.querySelectorAll('input[type="radio"]')]
      this.panels = [...this.querySelectorAll('[data-model-panel]')]
      this.images = [...this.querySelectorAll('[data-model-image]')]
      this.descriptions = [...this.querySelectorAll('[data-model-description]')]
      this.purchases = [...this.querySelectorAll('[data-model-purchase]')]
      const representations = [[this.panels, 'modelPanel'], [this.images, 'modelImage'], [this.descriptions, 'modelDescription'], [this.purchases, 'modelPurchase']]
      if (!this.radios.length || representations.some(([nodes, key]) =>
        nodes.length !== this.radios.length || this.radios.some(radio => nodes.filter(node => node.dataset[key] === radio.value).length !== 1))) return

      this.controller = new AbortController()
      const { signal } = this.controller
      this.mobile = window.matchMedia('(max-width: 989px)')
      this.selected = this.radios.find(radio => radio.checked)?.value || this.radios[0].value
      this.addEventListener('change', event => {
        if (this.radios.includes(event.target)) this.select(event.target.value)
      }, { signal })
      this.addEventListener('shopify:block:select', event => {
        const block = event.target.closest('[data-model-block]')
        if (block && this.contains(block)) this.select(block.dataset.modelBlock)
      }, { signal })
      this.mobile.addEventListener('change', () => {
        const active = this.ownerDocument.activeElement
        const cardFocused = this.panels.some(panel => panel.contains(active))
        this.select(this.selected)
        if (this.mobile.matches && cardFocused) {
          this.radios.find(radio => radio.value === this.selected).focus()
        } else if (!this.mobile.matches && this.contains(active) && !cardFocused) {
          this.panels.find(panel => panel.dataset.modelPanel === this.selected).querySelector('a')?.focus()
        }
      }, { signal })
      this.select(this.selected)
      this.setAttribute('data-enhanced', '')
    }

    select(id) {
      if (!this.radios.some(radio => radio.value === id)) return
      this.selected = id
      this.radios.forEach(radio => { radio.checked = radio.value === id })
      this.images.forEach(image => { image.hidden = image.dataset.modelImage !== id })
      this.descriptions.forEach(description => { description.hidden = description.dataset.modelDescription !== id })
      this.purchases.forEach(purchase => { purchase.hidden = purchase.dataset.modelPurchase !== id })
    }

    disconnectedCallback() {
      this.controller?.abort()
      this.controller = null
      this.removeAttribute('data-enhanced')
      for (const nodes of [this.images, this.descriptions, this.purchases]) nodes?.forEach(node => { node.hidden = false })
    }
  })
}
